import { Component, HostListener, Input, OnInit } from '@angular/core';

import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';
import { LocalizeStringModel } from '@Core/Localization/models/localize-string.model';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { AlertTypeEnum } from '../../../../Common/MonitorShared/enum/alert-type.enum';
import { MonitorConfigService } from '@Common/MonitorShared/services/monitor-config.service';
import { AnalysisUpsellPopupComponent } from '../../../Briefings/components/AnalysisUpsellPopup/analysis-upsell-popup.component';

class AlertTypeInfo {
    icon: string;
    title: string;
    message: string;
    type: AlertTypeEnum;
    tooltip?: string;
}

@Component({
    selector: 'agpr-alert-create-dialog',
    templateUrl: './alert-create-dialog.component.html',
    styleUrls: ['./alert-create-dialog.component.scss'],
    standalone: false
})
export class AlertCreateDialogComponent extends AbstractDialogComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public id: string;
    @Input() heading: string|LocalizeStringModel;

    width: number = 25;
    cancelLabel: string = 'Core.button.cancel';

    loading: boolean = false;
    enableSurgeInsights: boolean = false;
    hasCoverageInsightsEnabled: boolean = false;

    alertTypes: AlertTypeInfo[] = [
        {
            icon: 'fa-kit-duotone fa-agpr-alert-breaking',
            title: 'Alerts.createDialog.recent.title',
            message: 'Alerts.createDialog.recent.message',
            type: AlertTypeEnum.RECENT
        },
        {
            icon: 'fa-kit-duotone fa-agpr-alert-momentum',
            title: 'Alerts.createDialog.surge.title',
            message: 'Alerts.createDialog.surge.message',
            type: AlertTypeEnum.SURGE
        }
    ];
    alertTypeEnum = AlertTypeEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private monitorConfigService: MonitorConfigService
    ) {
        super(coreDialogService, 'TextInput');
    }

    ngOnInit(): void {
        this.monitorConfigService.getHasCoverageInsightsEnabled().subscribe(x => {
            this.hasCoverageInsightsEnabled = x;
        });
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        this.cancel();
    }

    openUpsell(event: MouseEvent): void {
        event.stopPropagation();
        const popupWidth = 485;
        const popupHeight = 372;
        const offsetSmall = 20;
        const mousePositionX = event.clientX || 0;
        const mousePositionY = event.clientY || 0;
        const positionX = Math.max(offsetSmall, mousePositionX - popupWidth / 2);
        const positionY = Math.max(offsetSmall, mousePositionY - popupHeight - offsetSmall);
        this.coreDialogService.open(AnalysisUpsellPopupComponent, {
            inputs: { positionX, positionY }
        });
    }

    setNewAlertType(alertType: AlertTypeInfo) {
        this.closeDialog({ alertType: alertType.type, enableSurgeInsights: this.enableSurgeInsights });
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog();
    }
}
